// A plain <a href> cannot carry the bearer, so downloads go through the
// authenticated fetch and hand the browser an object URL.
export async function saveBlob(blob, filename, doc = globalThis.document, urlApi = globalThis.URL) {
  const href = urlApi.createObjectURL(blob);
  try {
    const a = doc.createElement("a");
    a.href = href;
    a.download = filename;
    doc.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    setTimeout(() => urlApi.revokeObjectURL(href), 10_000);
  }
}
